import { useContext } from 'react';
import { WeekView } from '@devexpress/dx-react-scheduler-material-ui';
import { SchedulerContext } from '../../SchedulerContext';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<void, 'minWidthAdjustment'>()(
  (theme, _params, classes) => ({
    weekViewDayScaleLayoutCustom: {
      minWidthAdjustment: {},
      [`&.${classes.minWidthAdjustment}`]: {
        [theme.breakpoints.down('sm')]: {
          minWidth: '0px !important',
        },
      },
    },
    minWidthAdjustment: {},
  })
);

export const WeekViewDayScaleLayoutCustom = (
  props: WeekView.DayScaleLayoutProps
) => {
  const { classes, cx } = useStyles();
  const schedulerContext = useContext(SchedulerContext);
  return (
    <WeekView.DayScaleLayout
      {...props}
      className={cx({
        [classes.weekViewDayScaleLayoutCustom]: !schedulerContext.overView,
        [classes.minWidthAdjustment]: !schedulerContext.overView,
      })}
    ></WeekView.DayScaleLayout>
  );
};
